import React, { useState } from "react";
import { Mutation, Query } from "react-apollo";
import { Message } from "semantic-ui-react";
import { Trans } from "react-i18next";

import registerForTrainingUnitMutation from "../../../../gql/registerForTrainingUnitMutation";
import userAccountsQuery from "../../../../gql/userAccountsQuery";
import { toastTranslated } from "../../../../toastr/toastr";
import transError from "../../../../i18n/fieldError";
import { ROLE_MEMBER } from "../../../../security/role";
import RegisterByAdmin from "./RegisterByAdmin";

function RegisterByAdminContainer({
  trainingUnitId,
  registrations,
  onFinished
}) {
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const gqlVariables = {
    filter: {
      roleIdentifier: ROLE_MEMBER,
      term: searchTerm
    },
    sorting: { sortBy: "firstName", sortReversed: false }
  };

  const handleRegister = mutateFunc => () => {
    mutateFunc({
      variables: {
        registration: {
          trainingUnitId: trainingUnitId,
          memberId: selectedMemberId
        }
      }
    }).then(({ data: { result } }) => {
      if (result.error) {
        result.error.errors.forEach(error => {
          toastTranslated(
            "error",
            transError(`registration.${error.code}`, error.arguments)
          );
        });

        return;
      }

      toastTranslated("success", "coursePlan.events.registrationSuccess");

      setSelectedMemberId(null);
      onFinished();
    });
  };

  return (
    <Mutation mutation={registerForTrainingUnitMutation} ignoreResults={false}>
      {mutateFunc => (
        <Query
          query={userAccountsQuery}
          variables={gqlVariables}
          fetchPolicy="cache-and-network"
        >
          {({ loading, error, data }) => {
            if (error) {
              return (
                <Message error content={<Trans i18nKey="errors.noData" />} />
              );
            }

            let options = [];

            if (data && data.userAccounts && data.userAccounts.results) {
              const filteredAccounts = data.userAccounts.results.filter(
                user => {
                  return (
                    registrations.findIndex(
                      reg => reg.member.id === user.id && !reg.canceled
                    ) === -1
                  );
                }
              );

              options = filteredAccounts.map(member => ({
                key: member.id,
                text: `${member.firstName} ${member.lastName} (${member.emailAddress})`,
                value: member.id
              }));
            }

            return (
              <RegisterByAdmin
                selectedMemberId={selectedMemberId}
                selectMemberId={setSelectedMemberId}
                options={options}
                isLoading={loading}
                onSearchChange={setSearchTerm}
                onRegister={handleRegister(mutateFunc)}
              />
            );
          }}
        </Query>
      )}
    </Mutation>
  );
}

RegisterByAdminContainer.displayName =
  "coursePlan/details/registrations/RegisterByAdminContainer";

export default React.memo(RegisterByAdminContainer);
